$(document).ready(function() {
    if (window.location.hash) {
        const hash = window.location.hash.substring(1);

        const targetId = parseInt(hash.replace(/\D/g, ''), 10);
        const $targetElement = $("#" + targetId);

        if ($targetElement.length) {
            $targetElement.addClass('highlight');

            $targetElement[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }
});
